export const MAIN_ROUTE = '/'
export const NEWS_ROUTE = '/aktualnosci'
export const EVENTS_ROUTE = '/wydarzenia'
export const PARTNERS_ROUTE = '/partnerzy'
export const MEET_ROUTE = '/zorganizuj-u-nas-spotkanie'
export const FOR_FAMILY_ROUTE = '/dla-rodzin'
export const CONTACT_ROUTE = '/kontakt'
export const ABOUT_ROUTE = '/o-nas'
export const INFORM_ROUTE = '/klauzula-informacyjna'
export const EMPTY_ROUTE = '/404';